import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Blog.css';

const Blog = () => {
  const { t } = useTranslation();
  const [blogEnabled, setBlogEnabled] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetch('/api/home-content')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setBlogEnabled(data.content?.settings?.blogEnabled || false);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="blog-page">
        <section className="blog-content section">
          <div className="container">
            <p>{t('loading') || 'Loading...'}</p>
          </div>
        </section>
      </div>
    );
  }

  if (!blogEnabled) {
    return (
      <div className="blog-page">
        <section className="blog-hero">
          <div className="container">
            <h1>{t('blog.title')}</h1>
          </div>
        </section>
        <section className="blog-content section">
          <div className="container">
            <div className="text-center">
              <h2>{t('blog.disabled') || 'Blog Currently Unavailable'}</h2>
              <p>{t('blog.disabledMessage') || 'The blog is currently disabled. Please check back later.'}</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <section className="blog-hero">
        <div className="container">
          <h1>{t('blog.title')}</h1>
          <p>{t('blog.subtitle')}</p>
        </div>
      </section>

      <section className="blog-content section">
        <div className="container">
          <div className="text-center">
            <h2>{t('blog.recent')}</h2>
            <p>{t('blog.comingSoon')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
